import memoizeOne from 'memoize-one'
import { add, map } from 'ramda'

import { FETCH_SCOPING_KEYS } from '~/src/Journal/constants'
import {
  defer,
  EMPTY_OBJECT,
  equals,
  memoize,
  noop,
} from '~/src/Lib/Utils'

export const getOnItemsRendered = memoizeOne((after, dispatch, onItemsRendered) => {
  const transform = map(add(after))

  return indices => {
    dispatch('scrollerIndices', indices)
    onItemsRendered(transform(indices))
  }
})

export const getListRef = memoizeOne((listRef, infiniteLoaderListRef) => el => {
  infiniteLoaderListRef(el)
  listRef.current = el
})

export const getSetSelectedDate = memoize(({ dispatch }, day, cb = noop) => () => {
  dispatch('selectedDate', day)
  defer(cb, 33)
})

const scopingKeyToParam = {
  activeUser: 'relatedUser'
}
const getScopingParams = data => FETCH_SCOPING_KEYS.reduce((scopingParams, key) => (
  data[key] != null
    ? { ...scopingParams, [scopingKeyToParam[key] ?? key.replace('active', '').toLowerCase()]: data[key]?.id ?? data[key] }
    : scopingParams
), EMPTY_OBJECT)
export const getFetch = memoizeOne(({
  activeHarvest,
  harvestDates,
  doJournalFetch
}, dispatch) => async (params, replace = false) => {
  const scoping = getScopingParams(params)

  const { start, end } = params
  dispatch('loading', true)
  const response = await doJournalFetch({
    ...scoping,
    start: harvestDates ? activeHarvest.startDate : start?.toISODate(),
    end: harvestDates ? activeHarvest.endDate : end?.toISODate(),
  }, { replace })
  dispatch('loading', false)
  return response
}, equals)
